import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bell, Users, BarChart, Settings, LogOut, Plug } from 'lucide-react';
import TiccAIlogo from '../assets/TiccAIlogo.png';

interface NavigationProps {
  onSignOut: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onSignOut }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="w-64 bg-[#0F1824] border-l border-white/[0.5] order-last">
      <div className="p-4">
        <Link to="/" className="flex items-center gap-2 px-2">
          <img src={TiccAIlogo} alt="TiccAI" className="h-8 w-8" />
          <span className="text-xl font-bold text-white">TiccAI</span>
        </Link>
        
        <nav className="mt-8 space-y-1">
          <Link
            to="/dashboard"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
              isActive('/dashboard')
                ? 'text-pink-500 bg-pink-500/10'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <BarChart className="h-5 w-5" />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/integrations"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
              isActive('/integrations')
                ? 'text-pink-500 bg-pink-500/10'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <Plug className="h-5 w-5" />
            <span>Integrations</span>
          </Link>
          <Link
            to="/tickets"
            className="flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            <Bell className="h-5 w-5" />
            <span>Tickets</span>
          </Link>
          <Link
            to="/team"
            className="flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            <Users className="h-5 w-5" />
            <span>Team</span>
          </Link>
          <Link
            to="/settings"
            className="flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            <Settings className="h-5 w-5" />
            <span>Settings</span>
          </Link>
        </nav>
      </div>

      <div className="absolute bottom-4 w-64 px-4">
        <button
          onClick={onSignOut}
          className="flex items-center gap-2 px-4 py-2 text-gray-400 hover:text-white transition-colors w-full"
        >
          <LogOut className="h-5 w-5" />
          <span>Sign out</span>
        </button>
      </div>
    </div>
  );
};

export default Navigation;